import { INVENTORY_SECTIONS, type ServicesProvider } from '@ekhodealer/ekho-common';

import type { ServiceAccessObject } from '@ekhodealer/ekho-common';

import { getCombinedServiceSections } from '@features/account-management/lib/serviceFormConfig/formConfigs/utils/serviceAccess';

import {
	NAVIGATION_ITEMS,
	type NavigationItemConfig,
	type NavigationItemId,
} from './navigationItems';

/**
 * Check if a navigation item should be visible based on services provider configuration.
 */
export function isNavigationItemVisible(
	itemId: NavigationItemId,
	serviceAccess: ServiceAccessObject | null | undefined,
): boolean {
	switch (itemId) {
		case 'orders':
		case 'preorders':
		case 'discounts':
		case 'leads':
		case 'conversations':
		case 'analytics':
		case 'settings':
		case 'documentation':
		case 'reports':
			return true;

		case 'usage':
		case 'plan-details':
			return false; //WIP

		case 'inventory': {
			if (!serviceAccess) return false;
			const allowedServices = getCombinedServiceSections(serviceAccess);
			return Object.values(INVENTORY_SECTIONS).some((section) =>
				allowedServices.includes(section),
			);
		}

		default:
			return false;
	}
}

/**
 * Get all visible navigation items for a services provider.
 */
export function getVisibleNavigationItems(
	servicesProvider: ServicesProvider | null | undefined,
): NavigationItemConfig[] {
	return Object.values(NAVIGATION_ITEMS).filter((item) =>
		isNavigationItemVisible(item.id, servicesProvider?.serviceAccess),
	);
}
